import React from 'react';
import './Styles/Section.scss';

const Section=(props)=>{
    return(
        <div className="monzo-section">
            {props.title ? <h2>{props.title}</h2> : null}
            {props.desc ? <p>{props.desc}</p> : null}
        </div>
    )
};
export default Section ;